import React from 'react';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import { createCategoryAction, getCategoryTypeAction } from '../../../store/actions/CategoryActions';
import { useHistory } from 'react-router-dom';

const Category = (props) => {

    const history = useHistory()

    const dispatch = useDispatch();
    const [submit, setSubmit] = useState(false);

    const [category, setCategory] = useState({
        name: "",
        image: "",
        description: "",
        item_categry_type_id: "",
        status: 1
    });



    const categoryTypes = useSelector((state) => state.allCategories?.categoryType?.payload);

    const categoryTypeOptions = categoryTypes?.map(category => {
        const option = {};
        option['value'] = category.id;
        option['label'] = category.name;
        //option['name'] = 'category_id';
        return option;
    });

    function onFormFieldChange(e) {
        if (e.target.name != '') {
            setSubmit(true);
        }
        setCategory({
            ...category,
            [e.target.name]: e.target.value
        });
    }

    function onFormSelectChange(e) {
        setCategory({
            ...category,
            [e.target.name]: e.target.value
        });
    }


    function onFormSubmit(e) {
        e.preventDefault();
        try {
            dispatch(createCategoryAction(category, props.handleDetailsSidebar));
        } catch (error) {
            console.log("Something is wrong");
        }
    }


    function fetchCategoryTypes() {
        dispatch(getCategoryTypeAction());
    }

    useEffect(() => {
        fetchCategoryTypes();
    }, []);



    return (
        <div className='category'>
            <div style={{ height: "240vh", overflow: "scroll" }}>
                <form>
                    <div className="card rounded-0 add-menu-card">
                        <div className="card-header">
                            <b>Category Details</b>
                            {submit && <button className='btn btn-xs rounded-0' type='submit' onClick={onFormSubmit} style={{ color: 'white', backgroundColor: '#000000' }}>Save</button>}
                        </div>
                        <Alert severity="info">
                            Individual menu items will be grouped in the categories when shown to customers.
                            Please ensure that names and descriptions are correct as they will be visible to customers.
                        </Alert>
                        <div className='catery-add-form'>
                            <TextField id="standard-basic" name='name' label="Category Name *" variant="standard" onChange={onFormFieldChange} />
                            <div className='mt-5'>

                                <FormControl variant="standard" sx={{ m: 1, minWidth: 535 }}>
                                    <InputLabel id="demo-simple-select-standard-label">Category Type</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        onChange={onFormSelectChange}
                                        label="Category Type"
                                        name="item_categry_type_id"
                                    >
                                        {categoryTypeOptions?.map((option) => (
                                            <MenuItem key={option?.value} value={option?.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            <div className='mt-5'>
                                <TextField id="standard-basic" name="description" label="Category Description(optional)" variant="standard" onChange={onFormFieldChange} />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Category;